import React from 'react';
import { ActivationCard } from './ActivationCard';

interface AbortedScreenProps {
  onStartOver: () => void;
  title?: string;
  message?: string;
}

export const AbortedScreen: React.FC<AbortedScreenProps> = ({
  onStartOver,
  title = 'Registration Aborted',
  message = 'The RFID activation has been cancelled and the request was revoked.',
}) => (
  <ActivationCard>
    <div className="text-center">
      <div className="mb-4">
        <i className="fas fa-ban text-secondary" style={{ fontSize: '4rem' }}></i>
      </div>
      <h1 className="h3 mb-3 fw-bold">{title}</h1>
      <p className="text-muted mb-4">{message}</p>
      <div className="alert alert-secondary" role="alert">
        <i className="fas fa-info-circle me-2"></i>
        You can restart the registration process at any time.
      </div>
      <button onClick={onStartOver} className="btn btn-primary w-100">
        <i className="fas fa-redo me-2"></i>
        Start Over
      </button>
    </div>
  </ActivationCard>
);
